module.exports = __webpack_public_path__ + "media/images/buttons/button-social-facebook-bfac29274d0ab9ada81c9c9692e2d461.svg";